import { CustomEditor } from '../../../../models/slate-editor';
import { Editor, Range, Path } from 'slate';
import { cloneDeep } from 'lodash';

export const getSpacesRange = (editor: CustomEditor, range: Range): Range => {
  // Get start and end, modify it as we move along.
  const [start, end] = Range.edges(range);

  const next = Editor.after(editor, end, {
    unit: 'character'
  });
  const prev = Editor.before(editor, start, {
    unit: 'character'
  });
  const nextWord = next && Path.equals(end.path, next.path) && Editor.string(editor, { anchor: end, focus: next });
  const prevWord = prev && Path.equals(start.path, prev.path) && Editor.string(editor, { anchor: prev, focus: start });
  const newRange = cloneDeep(range);
  if (next && nextWord === ' ') {
    newRange.focus = next;
  }
  if (prev && prevWord === ' ') {
    newRange.anchor = prev;
  }

  if (Range.equals(newRange, range)) {
    return range;
  }
  return getSpacesRange(editor, newRange);
};
